(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAntragsuebersicht', {
            bindings: {
                angebotModel: '<abaAngebotModel',
                options: '<abaOptions'
            },
            templateUrl: 'bloecke/antragsuebersicht/blockAntragsuebersicht.html',
            controller: BlockAntragsuebersichtController,
            controllerAs: 'blockAntragsuebersichtVm'
        });

    BlockAntragsuebersichtController.$inject = [
        '$scope',
        '$q',
        '$modal',
        'lodash',
        'AppConfig',
        'MiscUtilsService',
        'BasisAngebotService',
        'WaitOverlayService',
        'BinaryUtilsService',
        'FilecacheService',
        'FormatUtilsService'
    ];
    function BlockAntragsuebersichtController($scope, $q, $modal, _, AppConfig, MiscUtilsService, BasisAngebotService, WaitOverlayService, BinaryUtilsService, FilecacheService, FormatUtilsService) {
        var vm = this,
            AngebotSpezifischService;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.isVisible = isVisible;
        vm.drucken = drucken;

        function activate() {
            vm.options = vm.options || {};
            AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(vm.angebotModel.angebot) + 'Service');
        }

        function onInit() {
            activate();
        }

        function onChanges() {
            activate();
        }

        function isVisible() {
            if (angular.isFunction(AngebotSpezifischService.getPrintAbschlussType)) {
                return AngebotSpezifischService.getPrintAbschlussType(vm.angebotModel.angebot) === 'REPORT';
            } else {
                return AppConfig.APP.printAbschlussType === 'REPORT';
            }
        }
        function drucken(name) {
            var cachedFile,
                deferred,
                pdfLoadedDeferred,
                modalPdfViewer,
                overlay,
                pdfName;

            pdfName = AppConfig.ANGEBOT.pdfNames.antragUebersicht;

            if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                vm.isWaitOverlayOpened = true;

                vm.waitOverlay = {
                    url: AppConfig.ANGEBOT.waitHelperUrl,
                    options: {
                        id: 'wgv',
                        logo: 'wgv_logo.svg',
                        message: AppConfig.MESSAGES.druckenPopup,
                        popupName: pdfName.bezeichnung,
                        popupWidth: 720,
                        popupHeight: 610,
                        showLoading: true
                    }
                };
            } else {
                deferred = $q.defer();
                pdfLoadedDeferred = $q.defer();

                modalPdfViewer = $modal.open({
                    templateUrl: 'modal/modalPdfViewer.html',
                    windowClass: 'xlarge pdfjs',
                    controller: 'ModalPdfViewerController',
                    controllerAs: 'modalVm',
                    resolve: { /* @ngInject */
                        pdf: [function () {
                            return deferred.promise;
                        }]
                    }
                });

                modalPdfViewer.result.then(function () {
                }).catch(function (error) {
                });

                deferred.resolve(pdfLoadedDeferred);
            }

            BasisAngebotService.antragUebersichtDrucken(vm.angebotModel).then(function (data) {
                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                    overlay = WaitOverlayService.get();
                }

                BinaryUtilsService.convertBinaryToFile(data.binary, 'pdf').then(function (file) {
                    cachedFile = FilecacheService.addFile({
                        name: FormatUtilsService.replace(pdfName.name, BasisAngebotService.getAngebotsnummer(vm.angebotModel.angebot, true)),
                        type: 'report',
                        bezeichnung: pdfName.bezeichnung,
                        blobUrl: file.blobUrl,
                        blob: file.blob,
                        filename: data.filename
                    });
                    vm[name + 'Pdf'] = cachedFile;

                    if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                        $scope.$emit('iplusjs:openFile', cachedFile, overlay.popup);
                        WaitOverlayService.close(false);
                    } else {
                        pdfLoadedDeferred.resolve(cachedFile);
                    }
                }).catch(function () {
                    if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                        vm.waitOverlay = null;
                        WaitOverlayService.close();
                    } else if (pdfLoadedDeferred) {
                        pdfLoadedDeferred.reject();
                    }
                });
            }).catch(function (error) {
                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                    vm.waitOverlay = null;
                    WaitOverlayService.close();
                } else if (pdfLoadedDeferred) {
                    pdfLoadedDeferred.reject();
                }
            }).finally(function () {
                if (!MiscUtilsService.isPdfjsViewerEnabled()) {
                    vm.isWaitOverlayOpened = false;
                }
            });
        }
    }

})();
